import React from 'react';

import css from '../../markdown.module.css';

type Props = {
	/** кому принадлежат слова: подпись под цитатой */
	source?: string;
};

/** Цитата с подписью: `[quote source="Эльминстер"]Текст цитаты[/quote]` */
export const Quote: React.FC<React.PropsWithChildren<Props>> = ({source, children}) => (
	<blockquote className={css.blockquote}>
		{children}
		{source && <div className={css.blockquoteAuthor}>{source}</div>}
	</blockquote>
);
